module.exports = __webpack_public_path__ + "static/media/Open.0ec5fe05.svg";